<style lang="scss" scoped>
.partner-content {
  height: calc(80vh - 90px);
}
.partner-list {
  overflow-y: auto;
  display: none;
}
@media (min-width: 768px) {
  .partner-content {
    height: calc(80vh - 51px);
  }
  .partner-list {
    display: block;
  }
}
.mark-read {
  color: $primary;
  cursor: pointer;
  &:hover {
    background-color: lighten(#f2f2f2, 2%);
  }
}
</style>
<template>
  <div
    class="col-12 partner-list border-right"
    :class="{ 'd-block': showPartner }"
  >
    <div class="row">
      <div
        @click="markAllAsRead()"
        class="col-12 p-1 text-center border-bottom btn d-block mark-read"
      >
        Nachrichten als gelesen makieren
      </div>
    </div>
    <dialog-partner
      v-for="partner in dialogPartners"
      :key="partner.id"
      :dialogPartner="partner"
      :selected="
        (showSupportMessages && partner.id === undefined) ||
          (activeDialogPartnerId !== undefined &&
            partner.id === activeDialogPartnerId)
      "
      @click.native="$emit('display-chat', partner)"
    ></dialog-partner>
    <div v-if="canLoadMorePartners" class="p-3">
      <v-button
        @click.native="$emit('load-more-dialogs')"
        type="button"
        class="mx-auto d-block"
        :working="loading"
      >
        Ältere Dialoge laden
      </v-button>
    </div>
  </div>
</template>
<script lang="babel">

import DialogPartner from '@/components/Customer/DialogPartner.vue';
import swal from "sweetalert2";
export default {
  components: {
    DialogPartner,
  },
  data() {
    return {
      showContent: false,
      activeDialogPartnerId: null,
      displayDialogInfo: false
    };
  },
  props: {
      loading: {
          required: false,
          type: Boolean,
          default: false,
      },
      dialogPartners: {
          required: true,
          type: Array,
      },
        showPartner: {
          required: false,
          type: Boolean,
          default: true
      },
        showSupportMessages: {
          required: false,
          type: Boolean,
          default: false
      }
  },
  computed: {
    canLoadMorePartners() {
      return this.$store.getters["dialog/count"] > this.$store.getters["dialog/dialogs"].length;
    },
  },
  methods: {
    markAllAsRead() {
      swal
        .fire({
          title: "Möchtest du alle Nachrichten als gelesen markieren?",
          text: "Es werden alle Nachrichten als gelesen markiert, die Chats blinken nicht mehr und der Zähler wird zurückgesetzt.",
          showCancelButton: true,
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#d33",
          confirmButtonText:"Ja",
          cancelButtonText: "Nein",
          type: "warning",
        })
        .then(result => {
          if (result.value) {
            this.$http.post(`/api/v1/message/mark-all-as-read`).then(() => {
              location.reload();
            }).finally(() => {
              swal
                .fire({
                  title: "Erfolgreich als gelesen markiert",
                  type: "success",
                  confirmButtonColor: "#28a745",
                  confirmButtonText: "Ok",
                });
            });
          }
        });
    },
  }
}
</script>
